import {
  SvgCompany,
  SvgFormUser,
  SvgPhone,
  SvgEnvelop,
} from "../../assets/icons";
import { WithIconTextareaFormInput } from "../generic/forms/withIconTextAreaFormInput";
import { SelectPickerFormInput } from "../generic/forms/selectPickerFormInput.component";
import { RadioFormInput } from "../generic/forms/RadioFormInput.component";
import { DateFormInput } from "../generic/forms/DateFormInput.component";
import { UtilityDate } from "../generic/dateUtil";
import { useEffect, useState } from "react";
import { UserAddFormType } from "../../models/forms/usersAddForm";
import { TrialUserExpiredData } from "../../core/ConstData/UserConstData";
import isBefore from "date-fns/isBefore";
import { paidFeaturesStaticData } from "../../data/paidFeaturesStaticData";

export const UsersEditForm = ({
  isPaid,
  userSubscriptionType,
  expiredDateChange,
  formValue,
}: {
  isPaid: boolean;
  userSubscriptionType: string;
  expiredDateChange: (date: Date, expireCount: number | string) => void;
  formValue: UserAddFormType;
}) => {
  const [expireDayCount, setExpireDayCount] = useState<Number | string>(0);
  const [checkValue, setCheckValue] = useState<boolean>(false);
  const [expiredDate, setExpiredDate] = useState<Date>();
  const [isTrialSelect, setIsTrial] = useState<boolean>();
  const handleExpireDateValue = (value: number) => {
    if (value === 3)
      expiredDateChange(UtilityDate.addThreeMonthDate(new Date()), 3);
    else if (value === 1)
      expiredDateChange(UtilityDate.addOneMonthDate(new Date()), 1);
    else if (value === 2)
      expiredDateChange(UtilityDate.addTwoDaysDate(new Date()), 2);
    else if (value === 7)
      expiredDateChange(UtilityDate.addSevenDaysDate(new Date()), 7);
    else if (value === 12)
      expiredDateChange(UtilityDate.addOneYearDate(new Date()), 12);
    else expiredDateChange(new Date(), 0);
  };

  const handleExpiredDateManulChange = (date: Date) => {
    expiredDateChange(
      date,
      parseInt(
        (
          Math.abs(date.getTime() - new Date().getTime()) /
          (1000 * 60 * 60 * 24)
        ).toPrecision()
      ).toString() + "d"
    );
  };
  useEffect(() => {
    console.log("formValue", formValue);
    if (formValue.expireDayCount) {
      setExpireDayCount(formValue.expireDayCount);
    }
    setExpiredDate(formValue.expiryDate);
  }, [formValue]);

  useEffect(() => {
    if (userSubscriptionType === "trial") setCheckValue(false);
    else setCheckValue(true);
  }, []);

  useEffect(() => {
    if (isTrialSelect) {
      setExpireDayCount(1);
      expiredDateChange(UtilityDate.addOneMonthDate(new Date()), 1);
      if (!formValue.expiryDate)
        setExpiredDate(UtilityDate.addOneMonthDate(new Date()));
    } else if (isTrialSelect === false) {
      setExpireDayCount(12);
      expiredDateChange(UtilityDate.addOneYearDate(new Date()), 12);
    }
  }, [isTrialSelect]);

  const onTrialOrPaidChecked = (isTrial: boolean) => {
    setIsTrial(isTrial);
  };

  return (
    <div className="d-flex flex-column px-3">
      <h6 className="mb-3 mt-1">Sign In Information</h6>
      <p className="fw-bold mb-1 card-text ms-1">Email</p>
      <WithIconTextareaFormInput
        className=" m-0 w-100 disabled"
        placeholder="Please enter email"
        name="email"
        svgicon={SvgEnvelop}
      />
      <p className="fw-bold mt-3 mb-1 card-text ms-1">User Name</p>
      <WithIconTextareaFormInput
        className=" m-0 w-100 disabled"
        name="userName"
        svgicon={SvgFormUser}
      />
      <h6 className="mb-3 mt-4">Basic Information</h6>
      <p className="fw-bold mb-1 card-text ms-1">First Name</p>
      <WithIconTextareaFormInput
        className=" m-0 w-100"
        placeholder="Please enter firstname"
        name="firstName"
        svgicon={SvgFormUser}
      />
      <p className="fw-bold mt-3 mb-1 card-text ms-1">Last Name</p>
      <WithIconTextareaFormInput
        className=" m-0 w-100"
        name="lastName"
        placeholder="Please enter lastname"
        svgicon={SvgFormUser}
      />
      <p className="fw-bold mt-3 mb-1 card-text ms-1">Company Name</p>
      <WithIconTextareaFormInput
        className=" m-0 w-100"
        name="companyName"
        placeholder="Please enter company name"
        svgicon={SvgCompany}
      />
      <p className="fw-bold mt-3 mb-1 card-text ms-1">Type Of Company</p>
      <div className="p-0">
        <SelectPickerFormInput
          name="typeOfCompany"
          data={[
            { label: "Law Firm", value: "LawFirm" },
            { label: "Corporate", value: "Corporate" },
            { label: "Others", value: "other" },
          ]}
          placeholder="Law Firm"
          size="sm"
          placement="topStart"
          block
          searchable={false}
        />
      </div>
      <p className="fw-bold mt-3 mb-1 card-text ms-1">WTA Subscription Type</p>
      <div className="p-0">
        <SelectPickerFormInput
          name="wtaSubType"
          data={[
            { label: "None", value: "None" },
            { label: "Basic", value: "Basic" },
            { label: "Emplus", value: "Emplus" },
          ]}
          size="sm"
          placement="topStart"
          block
          searchable={false}
        />
      </div>
      <p className="fw-bold mt-3 mb-1 card-text ms-1">TPA Subscription Type</p>
      <div className="p-0">
        <SelectPickerFormInput
          name="tpaSubType"
          data={[
            { label: "None", value: "None" },
            { label: "Basic", value: "Basic" },
            { label: "Emplus", value: "Emplus" },
          ]}
          size="sm"
          placement="topStart"
          block
          searchable={false}
        />
      </div>
      <p className="fw-bold mt-3 mb-1 card-text ms-1">
        Paid Feature Subscription
      </p>{" "}
      <SelectPickerFormInput
        name="paidFeatureSubscriptionType"
        data={Object.entries(paidFeaturesStaticData)
          .filter(([key]) => isNaN(Number(key)))
          .map(([key, value]) => ({
            label: key,
            value: key,
          }))}
        placeholder="Select Paid Feature"
        // defaultValue={paidFeaturesStaticData.None.toString()}
        size="sm"
        placement="topStart"
        block
        searchable={false}
        // showError={true}
        // errorPlacement="topEnd"
      />
      <p className="fw-bold mt-3 mb-1 card-text ms-1">Phone Number</p>
      <WithIconTextareaFormInput
        className=" m-0 w-100"
        name="phoneNumber"
        placeholder="Please enter phone number"
        svgicon={SvgPhone}
      />
      <h6 className="mb-3 mt-4">Account Details</h6>
      <div className="d-flex mt-1">
        <RadioFormInput
          name="userType"
          checked={checkValue}
          onTrialOrPaidChecked={onTrialOrPaidChecked}
        />
      </div>
      <div className="d-flex mt-1 ms-2 align-items-center mb-3 flex-row">
        <div className="d-flex flex-row align-items-center">
          <div className={`d-flex ${isPaid ? "disable-cursor disabled" : ""}`}>
            <p>Registered Date</p>
            <DateFormInput name="registrationDate" />
            <p className="ms-4">Expire Date</p>
            <DateFormInput
              name="expiryDate"
              value={expiredDate}
              disabledDate={(date: Date | undefined) =>
                date !== undefined
                  ? isBefore(
                      date,
                      formValue.registrationDate
                        ? formValue.registrationDate
                        : new Date()
                    )
                  : false
              }
              onChange={(date) => handleExpiredDateManulChange(date)}
            />
          </div>
        </div>
        {!isPaid ? (
          <div className="pl-2 text-dark">
            <SelectPickerFormInput
              name="expireDayCount"
              value={expireDayCount}
              data={TrialUserExpiredData}
              size="xs"
              placement="topEnd"
              searchable={false}
              isCleanable={false}
              onChange={(value) => {
                handleExpireDateValue(value);
                setExpireDayCount(value);
              }}
              showError={false}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
